import React from 'react';
import {
  EPromoBonusType,
  EPromoBonusTypeText,
  EPromoCriteriaType,
  EPromoCriteriaTypeText,
  EPromoCustomerSelectType,
  EPromoCustomerSelectTypeText,
  EPromoPeriodText,
  EPromoType,
  EPromoTypeText,
} from 'entities/Promo/Promo.models';
import { weekDaysOptionsFull } from 'entities/Promo/Promo.const';

export const selectBonus = (bonus?: EPromoBonusType): any => {
  switch (bonus) {
    case EPromoBonusType.DiscountAllPercent:
      return EPromoBonusTypeText.DiscountAllPercent;

    case EPromoBonusType.DiscountAllPeso:
      return EPromoBonusTypeText.DiscountAllPeso;

    case EPromoBonusType.DiscountItem:
      return EPromoBonusTypeText.DiscountItem;

    case EPromoBonusType.Additional:
      return EPromoBonusTypeText.Additional;

    case EPromoBonusType.AdditionalNotOnMenu:
      return EPromoBonusTypeText.AdditionalNotOnMenu;

    default:
      return 'Unknown bonus';
  }
};
export const selectCriteria = (bonus?: EPromoCriteriaType): any => {
  switch (bonus) {
    case EPromoCriteriaType.MenuItem:
      return EPromoCriteriaTypeText.MenuItem;

    case EPromoCriteriaType.Category:
      return EPromoCriteriaTypeText.Category;

    case EPromoCriteriaType.Price:
      return EPromoCriteriaTypeText.Price;
    case EPromoCriteriaType.EveryXPesos:
      return EPromoCriteriaTypeText.EveryXPesos;
    default:
      return 'Unknown criteria';
  }
};
export const selectPromoType = (promoType?: string): EPromoTypeText =>
  promoType === EPromoType.Code ? EPromoTypeText.Code : EPromoTypeText.Action;

export const selectCustomerType = (promoType: EPromoType | undefined, customerType?: string): EPromoCustomerSelectTypeText => {
  if (promoType === EPromoType.Refund) {
    return EPromoCustomerSelectTypeText.PesooffPromoCustomers;
  }

  switch (customerType) {
    case EPromoCustomerSelectType.New:
      return EPromoCustomerSelectTypeText.New;
    case EPromoCustomerSelectType.All:
      return EPromoCustomerSelectTypeText.All;
    default:
    case EPromoCustomerSelectType.Specific:
      return EPromoCustomerSelectTypeText.Specific;
  }
};

export const selectPromoPeriodText = (
  promoType: EPromoType | undefined,
  startTimeValue: string | null | undefined,
  endTimeValue: string | null | undefined
) => {
  if (promoType === EPromoType.Refund) {
    return EPromoPeriodText.pesooffPromoPeriod;
  }

  if (startTimeValue && endTimeValue) {
    return EPromoPeriodText.specificDateAndTime;
  }

  return EPromoPeriodText.specificDate;
};

export const selectWeekDaysText = (weekDays: ('mon' | 'tue' | 'wed' | 'thu' | 'fri' | 'sat' | 'sun')[] | undefined) => {
  if (!weekDays || !weekDays.length) {
    return '-';
  }

  const allDays = weekDaysOptionsFull.map((opt) => opt.value).sort();
  const sortedInput = [...weekDays].sort();

  // In case when all days selected
  if (JSON.stringify(sortedInput) === JSON.stringify(allDays)) {
    return 'Every Day';
  }

  // Map values to human-readable labels
  const labels = weekDays.map((day) => weekDaysOptionsFull.find((opt) => opt.value === day)?.label);

  // Get string with 'and'
  if (labels.length === 1) {
    return (
      <span>
        Every <span className="font-weight-5">{labels[0]}</span>
      </span>
    );
  } else if (labels.length === 2) {
    return (
      <span>
        Every <span className="font-weight-5">{labels[0]}</span> and <span className="font-weight-5">{labels[1]}</span>
      </span>
    );
  } else {
    const last = labels.pop();

    return (
      <span>
        Every <span className="font-weight-5">{labels.join(', ')}</span>, and <span className="font-weight-5">{last}</span>
      </span>
    );
  }
};
